

import { QuestionBase, QuestionElement, QuestionUITypes } from './question-base';
import {QuestionRow} from './question-row';

export class QuestionCol2 extends QuestionRow {
}


// WEBPACK FOOTER //
// ./src/app/question-col2.ts